import { defineSlotRecipe } from '@chakra-ui/react';

export const specialFeatureCardSlotRecipe = defineSlotRecipe({
	className: 'SpecialFeatureCard',
	slots:     [ 'root', 'overlay', 'title', 'image' ],

	base: {
		image: {
			display:      'grid',
			p:            4,
			placeContent: 'center',
			w:            '100%',
		},
		overlay: {
			backdropFilter: 'blur(2px)',
			bg:             'blackAlpha.500',
			inset:          0,
			position:       'absolute',
			zIndex:         4,
		},
		root: {
			_hover: {
				'& __overlay': {
					backdropFilter: 'blur(0px)',
					bg:             'blackAlpha.100',
				},
			},
		},
		title: {
			color:     'white',
			textAlign: 'center',
			textStyle: 'h3',
			zIndex:    5,
		},
	},
});
